import { newMapFormValues } from "@awe-web/shared/lib";
import { loadFormConfiguration, requestSignUp } from "@awe-web/shared/lib";
import { B2B_SignUpRequestSuccess } from "../../../routing/routes.js";

export const initialize = () => async (dispatch, getState, context) => {
  const captchaSiteKey = await context.api.user.getCaptchaSiteKey();
  await dispatch({
    type: "USER/CAPTCHA_SITEKEY_LOADED",
    payload: {
      captchaSiteKey: captchaSiteKey
    }
  });
  await dispatch(loadFormConfiguration("registerApplicant"));
};

export const submit = (formValues) => async (dispatch, getState, context) => {
  const mapFormValues = newMapFormValues("registerApplicant")(getState());
  const normalizedValues = mapFormValues(formValues);
  try {
    await dispatch(requestSignUp(normalizedValues));
    return B2B_SignUpRequestSuccess.path();
  } catch (error) {
    if (error.type === "CAPTCHA_REQUIRED") {
      return;
    }
  }

};
